import {
  LoadingButton,
  Timeline,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineItem,
  TimelineOppositeContent,
  TimelineSeparator,
} from "@mui/lab";
import {
  Avatar,
  Box,
  Divider,
  List,
  ListItemAvatar,
  ListItemButton,
  ListItemSecondaryAction,
  ListItemText,
  Pagination,
  Stack,
  TextField,
  Typography,
  useMediaQuery,
} from "@mui/material";
import moment from "moment";
import React, { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { dispatch } from "store";

import { useSearchParams } from "react-router-dom";
import {
  fillingPersonReturnSelector,
  getFillingPersonReturnThunk,
  readFillingPersonReturnThunk,
} from "store/reducers/inventory/stock/fillingPeronReturnLogSlice";
import { useTheme } from "@emotion/react";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { getTime, getTimeFromNow } from "utils/timeHelper";

const removeReason = {
  dam: "Damaged",
  exp: " Expired",
  qlt: "Quality Issue",
};

const FillingPersonStockReturns = () => {
  const [page, setPage] = useState(1);
  const [searchParams] = useSearchParams();
  const fillingPerson = searchParams.get("fillingPerson");
  const pageCount = useSelector(
    (state) => state.fillingPersonReturn.logPageCount
  );
  const theme = useTheme();
  const logs = useSelector(fillingPersonReturnSelector.selectAll);
  const fillingPersons = useSelector((state) => state.accounts.fillingPersons);
  const state = useSelector((state)=>state.fillingPersonReturn)
  const [filter, setFilter] = useState({
    from_date: null,
    to_date: null,
    fillingPerson: null,
  });

  useEffect(() => {
    dispatch(getFillingPersonReturnThunk());
  }, []);

  useEffect(() => {
    if (fillingPerson && fillingPersons) {
      const dist = fillingPersons.find(
        (item) => item.id === parseInt(fillingPerson)
      );
      setFilter((state) => ({ ...state, fillingPerson: dist }));
    }
  }, [fillingPerson, fillingPersons]);

  const getFillingPersonStockReturns = useCallback(() => {
    dispatch(
      getFillingPersonReturnThunk({
        page: page,
        from_date: moment(filter.from_date).isValid()
          ? moment(filter.from_date).toISOString()
          : "",
        to_date: moment(filter.to_date).isValid()
          ? moment(filter.to_date).toISOString()
          : "",
        fillingPerson: filter.fillingPerson?.profile?.id ?? "",
      })
    );
  }, [filter.fillingPerson, filter.from_date, filter.to_date, page]);
  useEffect(() => {
    getFillingPersonStockReturns();
  }, [page]);

  const handlePageChange = (event, value) => {
    setPage(value);
    getFillingPersonStockReturns();
  };

  const avatarSX = {
    width: 36,
    height: 36,
    fontSize: "1rem",
  };
  const actionSX = {
    mt: "6px",
    ml: 1,
    top: "auto",
    right: "auto",
    alignSelf: "flex-start",

    transform: "none",
  };

  return (
    <Box padding={2}>
      <List
        component="nav"
        sx={{
          p: 0,
          "& .MuiListItemButton-root": {
            py: 0.5,
            "& .MuiAvatar-root": avatarSX,
            "& .MuiListItemSecondaryAction-root": {
              ...actionSX,
              position: "relative",
            },
          },
        }}
      >
        {logs.map((item, index) => (
          <Box
            key={item.id}
            sx={{
              ...(item.status && {
                bgcolor: theme.palette.action.selected,
              }),
            }}
          >
            <ListItemButton>
              <ListItemAvatar>
                <Avatar
                  sx={{
                    color: "warning.main",
                    bgcolor: "warning.lighter",
                  }}
                >
                  <WarningAmberIcon />
                </Avatar>
              </ListItemAvatar>

              <ListItemText
                primary={
                  <Typography variant="h6">
                    {item.filling_person_name}{" "}
                    <Typography component="span" variant="subtitle1">
                      Removed
                    </Typography>
                    <br />
                    product "{item.product_variant.product_detail.name}" Qty{" "}
                    {item.qty} for reason {""}
                    <Typography component="span" variant="subtitle1">
                      {removeReason[item.return_reason]}
                    </Typography>
                  </Typography>
                }
                secondary={getTimeFromNow(item.created_date)}
              />

              <ListItemSecondaryAction>
                <Typography variant="caption" noWrap>
                  {getTime(item.created_date)}
                </Typography>
              </ListItemSecondaryAction>
            </ListItemButton>
            <Stack direction="row" justifyContent="center">
              {!item.status && (
                <LoadingButton
                  color="info"
                  variant="outlined"
                  size="small"
                  loading={ state.readStatus.loading === item.id}
                  sx={{ ml: 1, my: 1, width: "14ch" }}
                  onClick={() => {
                    dispatch(readFillingPersonReturnThunk(item.id));
                  }}
                >
                  Verify
                </LoadingButton>
              )}
            </Stack>
            <Divider />
          </Box>
        ))}
      </List>

      <Stack direction="row" justifyContent="center">
        <Pagination
          count={pageCount}
          variant="outlined"
          shape="rounded"
          onChange={handlePageChange}
          sx={{mt:3}}
        />
      </Stack>
    </Box>
  );
};

export default FillingPersonStockReturns;
